import { combineReducers } from "redux";
import dbReducers from "./dbReducers";
import coreReducers from "./coreReducers";
import cartReducers from "./cartReducers";

export default combineReducers({
  core: coreReducers,
  db: dbReducers,
  cart: cartReducers
});